import { render, staticRenderFns } from "./ProductUpdateForm.vue?vue&type=template&id=07520d9e"
import script from "./ProductUpdateForm.vue?vue&type=script&lang=js"
export * from "./ProductUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports